var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bp-divider",class:_vm.dClass},[(_vm.$slots.default && _vm.type === 'horizontal')?_c('span',{staticClass:"bp-divider-text"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }